import { Card, Text } from '@global-ecom/nitro-uds/elements';

import { useTranslate } from 'hooks/useTranslations';

export const SoldOutBanner = ({
  message,
}: {
  message?: string | null | undefined;
}) => {
  const t = useTranslate();
  return (
    <Card variant="fill" insetY="sm">
      <Text
        asChild
        weight="bold"
        className="cursor-not-allowed text-center"
        size="base"
        transform="uppercase"
      >
        <p data-test-id="product-sold-out">{message || t('soldOut')}</p>
      </Text>
    </Card>
  );
};
